import { loadable } from '@fiverr-private/perseus';

const MiraJobDescriptionInput = loadable(
    () => import(/* webpackChunkName: "MiraJobDescriptionInput" */ './MiraJobDescriptionInput')
);

export const MIRA_JOB_DESCRIPTION_INPUT_CONFIG = {
    components: [
        {
            component: MiraJobDescriptionInput,
            options: {
                name: 'Mira Job Description Input',
                inputs: [
                    {
                        name: 'source',
                        type: 'text',
                        required: true,
                        defaultValue: 'content_pages_hero',
                        helperText:
                            'Sent to Mira as the `source` query param on submit, for attribution. Set a distinct value per page/placement.',
                    },
                    {
                        name: 'suggestions',
                        type: 'list',
                        subFields: [{ name: 'text', type: 'text', required: true }],
                        defaultValue: [
                            { text: "I'm not sure where to start" },
                            { text: "I'm ready to start working on a professional job description" },
                            { text: 'Our business needs a brand designer for a product launch' },
                        ],
                        helperText: 'Suggestion chips shown below the input. Clicking one fills the textarea.',
                    },
                    {
                        name: 'autoFocus',
                        type: 'boolean',
                        defaultValue: true,
                        helperText: 'Automatically focus the textarea on load.',
                    },
                ],
            },
        },
    ],
};
